export default __webpack_public_path__ + "static/media/rl.cc23e902.jpg";